export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const academicMonthOrder = {
    September: 1,
    October: 2,
    November: 3,
    December: 4,
    January: 5,
    February: 6,
    March: 7,
    April: 8,
    May: 9,
    June: 10,
    July: 11,
    August: 12
};

export const calendarMonthOrder = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12
}

export const radiusOpts = {
    pointRadius: 5,
    pointHoverRadius: 8
}
export const lineColors = [
    {
        //blue
        borderColor: 'rgb(53, 161, 235)',
        backgroundColor: 'rgba(31, 139, 213, 1)',
    },
    {
        //green
        borderColor: 'rgb(136, 163, 0)',
        backgroundColor: 'rgba(136, 163, 0, 1)',
    },
    {
        //red
        borderColor: 'rgb(253, 100, 132)',
        backgroundColor: 'rgba(253, 100, 132, 1)',
    },
    {
        //yellow
        borderColor: 'rgb(255, 205, 86)',
        backgroundColor: 'rgba(255, 205, 86, 1)',
    },

    {
        //purple
        borderColor: 'rgb(255, 81, 47)',
        backgroundColor: 'rgba(255, 81, 4, 1)',
    },
    {
        borderColor: 'rgb(45, 57, 159)',//dark blue
        backgroundColor: 'rgba(45, 57, 159, 1)',
    },
    {
        borderColor: 'rgb(0,100,0)',//dark green
        backgroundColor: 'rgba(0, 100, 0, 1)',
    },
    {
        borderColor: 'rgb(139,0,0)',//dark red
        backgroundColor: 'rgba(139,0,0, 1)',
    }
];
